export default {
  data() {
    return {
      tableDatas: [], // 表格数据数组

      pageData: {
        currentPage: 1, // 当前页码
        pageSize: 20, // 数据总数
        total: 0, // 页码尺寸
      },

      tableMaxHeight: 0
    }
  },
  methods: {
    // tableRowClassName({row, rowIndex}) {
    //   if (rowIndex%2) {
    //     return 'odd-row'
    //   }
    //   return ''
    // },
    // 点击 页码
    pageChange(pageNumber) {
      this.pageData.currentPage = pageNumber
      this.getTableData()
    },
    // getTableHeight() {
    //   if (this.$refs.tablebox) {
    //     this.tableMaxHeight = this.$refs.tablebox.getBoundingClientRect().height
    //   }
    // },
  },
  created() {
    this.tableMaxHeight = window.innerHeight - this.otherHeight
  },
  mounted () {
    const that = this
    window.onresize = () => {
      return (() => {
        // window.screenWidth = document.body.clientWidth
        // that.screenWidth = window.screenWidth
        that.tableMaxHeight = window.innerHeight - this.otherHeight
        console.log(`%c窗体变化，重新计算表格高度:`, 'color: #f00;', `${window.innerHeight}-${this.otherHeight}=${this.tableMaxHeight}`)
      })()
    }
  }
  // updated() {
  //   // 因為v-if的原因 table不會在created中繪製
  //   if (this.$refs.tablebox && !this.tableHeight) {
  //     console.log(`%c有数据变化，重新计算表格高度:`, 'color: #f00;', this.tableHeight, this.$refs.tablebox.getBoundingClientRect().height)
  //     this.tableMaxHeight = this.$refs.tablebox.getBoundingClientRect().height
  //   }
  // },
}